// extracted by mini-css-extract-plugin
export var content = "shared-module--content--1r5zX";
export var title = "shared-module--title--3cdfk";